import { DaemonModel, CommCodeModel, ComboModel } from '@common/DaemonProcessManagement/model';
import api from './api';
import * as types from './mutation-types';

export default {
	fetchProcesses_: ({ state, commit }, payload) => {
		return api
			.fetchProcesses(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: pagingInfo
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'processes',
						value: resultList.map(daemon => new DaemonModel(daemon))
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPlants_: ({ state, commit }) => {
		return api
			.fetchPlants()
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					const plants = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							plants
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds_: ({ state, commit }, payload) => {
		return api
			.fetchPgmIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							pgmIds: body.map(combo => new ComboModel(combo))
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchProcIdsByPgmId_: ({ state, commit }, payload) => {
		return api
			.fetchProcIdsByPgmId(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							procIds: body.map(combo => new ComboModel(combo))
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	setStatus_: ({ state, commit }, payload) => {
		return api
			.setStatus(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	getControl_({ state, commit, dispatch }, payload) {
		return api
			.getControl(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	returnControl_({ state, commit, dispatch }, payload) {
		return api
			.returnControl(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
